<template>
    <v-expansion-panels accordion>
        <v-expansion-panel class="expansion">
            <v-expansion-panel-header v-slot="{ open }">
                <div class="col-1 colLowPadding">
                    <v-icon class="handle" color="black">mdi-sort</v-icon>
                </div>
                <div class="row col-10 expansionHeaderText colLowPadding" v-if="open">
                    <div class="col-12 expansionHeaderText colLowPadding">
                        <p>Edit the custom blocks PHP script.</p>
                    </div>
                </div>
                <div v-else class="row col-10 expansionHeaderText colLowPadding">
                    <div class="col-12 expansionHeaderText colLowPadding">
                        <p>Custom block</p>
                    </div>
                </div>
                <div class="col-1 colLowPadding">
                    <v-btn @click="deleteBlock()" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <PrismEditor emitEvents
                             :line-numbers="true"
                             v-model="inner_data"
                             language="php"/>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    import PrismEditor from 'vue-prism-editor';

    export default {
        components: {
            PrismEditor
        },
        data() {
            return {
                inner_data: '// Put your script code here.\n' +
                    '// You can use the following variables: $data, $projectData, $project and $this->blockHelper.\n' +
                    'return $data; // Always return the data that is needed for the next blocks.',
            }
        },
        props: {
            block: {
                type: Object,
                default: {}
            },
            options: {
                type: Array,
                default: []
            },
            currentBlocks: {
                type: Array,
                default: []
            }
        },
        methods: {
            deleteBlock() {
                this.$emit('deleteBlock');
            }
        },
        created() {
            this.block.type = 'custom';
            this.block.methodName = null;
            if (this.block.code === undefined) {
                this.block.code = this.inner_data;
            } else {
                this.inner_data = this.block.code;
            }
        },
        watch: {
            inner_data: function (code) {
                this.block.code = code;
            }
        }
    }
</script>

<style>

    .v-application code {
        font-size: inherit;
        background-color: inherit;
        box-shadow: inherit;
        font-weight: inherit;
    }

</style>
